<template>
  <span>
    Group
    <em>devices</em> to conveniently manage user access and deploy {{ componentData }} en masse.
  </span>
</template>

<script>
export default {
  name: 'InstructionTextDeviceGroup',
  props: {
    componentData: {
      required: true,
      type: String,
    },
  },
};
</script>
